import flags from '../store/Store';
import type FeatureOverride from '../store/schema/FeatureOverride';

function updateActiveFlights(featureOverrides: FeatureOverride[], sourceId?: string) {
    for (let override of featureOverrides) {
        flags(sourceId).featureFlags.set(override.name.toLowerCase(), override.isEnabled);
    }
}

export default updateActiveFlights;
